<template>
  <div>
    <model-table
      :collection="pages"
      :columns="[
        { field: 'id' },
        { field: 'title' },
        { field: 'slug' },
        { name: 'sections', field: page => page.sections ? { value: page.sections.data.length, tooltip: $_.map(page.sections.data, 'name') } : null, component: 'chip' },
        { label: 'Views', field: 'viewsPastNinetyDays', component: 'chip' },
        { name: 'Visibility', field: page => page.displayIcons, component: 'icons' },
        { name: 'library', component: 'library-link', hide: currentCircuit.isLibrary },
        { name: 'actions', align: 'right' }
      ]"
      :has-library="!currentCircuit.isLibrary"
      :library-collection="pageLibrary"
      :library-columns="[
        { field: 'title' },
      ]"
      :link-filter="libraryFilterFunction"
      :orderable="true"
    >
      <template
        #prepend-row-actions="props"
      >
        <div
          class="row no-wrap items-center q-gutter-sm"
        >
          <q-btn
            v-if="!props.row.published || props.row.describeChanges"
            class="col-auto"
            :icon="props.row.published ? 'published_with_changes' : 'publish'"
            :color="props.row.published ? 'warning' : 'positive'"
            outline
            dense
            :loading="actionKey === 'publish-' + props.row.id"
            @click.stop="executeAction(props.row, 'publish')"
          >
            <q-tooltip>
              <div class="text-bold">
                Publish {{ props.row.published ? 'Changes' : '' }}
              </div>
              <div
                v-for="(change, index) in (props.row.describeChanges || '').split('\n')"
                :key="change + index"
              >
                {{ change }}
              </div>
            </q-tooltip>
          </q-btn>
          <q-btn
            v-if="props.row.describeChanges"
            class="col-auto"
            icon="undo"
            color="negative"
            outline
            dense
            :loading="actionKey === 'discardDraft-' + props.row.id"
            @click.stop="executeAction(props.row, 'discardDraft')"
          >
            <q-tooltip>
              <div class="text-bold">
                Discard Changes
              </div>
              <div
                v-for="(change, index) in props.row.describeChanges.split('\n')"
                :key="change + index"
              >
                {{ change }}
              </div>
            </q-tooltip>
          </q-btn>
          <q-btn
            v-if="props.row.published"
            class="col-auto"
            icon="visibility_off"
            color="negative"
            :loading="actionKey === 'unpublish-' + props.row.id"
            outline
            dense
            @click.stop="executeAction(props.row, 'unpublish')"
          >
            <q-tooltip>
              <div class="text-bold">
                Unpublish
              </div>
            </q-tooltip>
          </q-btn>
        </div>
      </template>
      <page-form
        @change="pages.fetch(true)"
      />
    </model-table>
  </div>
</template>

<script>
import ModelTable from 'src/modules/admin/components/ModelTable'
import PageForm from 'src/modules/admin/page/PageForm'

export default {
  name: 'PageTable',
  components: {
    ModelTable,
    PageForm
  },
  configuration: ['currentCircuit'],
  models: {
    pages: {
      draftParent: {
        fields: ['id', 'draftId'],
        sections: {
          fields: ['id', 'draftId']
        }
      },
      sections: {
        libraryParentId: true,
        receiveLibraryUpdates: true
      },
      viewsPastNinetyDays: true,
      describeChanges: true,
      libraryParentId: true,
      receiveLibraryUpdates: true,
      immediate: false
    },
    pageLibrary: {
      libraryChildSiteIds: true,
      variables () {
        return {
          searchString: this.libraryFilterString,
          limit: 10
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      actionKey: null,
      libraryFilterString: null
    }
  },
  methods: {
    async executeAction (page, action) {
      this.actionKey = action + '-' + page.id
      await page[action]()
      this.actionKey = null

      this.pages.fetch(true)
    },
    libraryFilterFunction (value) {
      this.libraryFilterString = !_.isEmpty(value) ? value.trim() : null
    }
  }
}
</script>
